import { makeServicesTypesFromEnum } from '@/core/container/makeServicesTypes'

enum SERVICES {
  OutboundEmailsGridable,
  OutboundEmailsBulkService,
  OutboundEmailsBulkManager,
  OutboundEmailsColumnServiceFactory,
  OutboundEmailsInsertContentColumnServiceFactory,
  OutboundEmailsTitlerService,
  OutboundEmailsResolverService,
  OutboundEmailsBulkResolverService,
  OutboundEmailsDetailsModalResolverService,
  OutboundEmailsDetailsService,
  OutboundEmailsDetailsRepository,

  OutboundEmailsBulkDetailsRecipientsColumnService,
  OutboundEmailsBulkDetailsRecipientsFilterServiceFactory,
  OutboundEmailsBulkDetailsRecipientsGridable,
  OutboundEmailsBulkDetailsRecipientsExportService,

  OutboundEmailsBulkDetailsOpensGridable,
  OutboundEmailsBulkDetailsOpensExportService,
  OutboundEmailsBulkDetailsOpensColumnService,

  OutboundEmailsBulkDetailsUnsubscribersGridable,
  OutboundEmailsBulkDetailsUnsubscribeExportService,
  OutboundEmailsBulkDetailsUnsubscribeColumnService,

  OutboundEmailsBulkDetailsSpamReportsColumnService,
  OutboundEmailsBulkDetailsSpamReportsGridable,
  OutboundEmailsBulkDetailsSpamReportsExportService,

  OutboundEmailsBulkDetailsClicksSummaryColumnService,
  OutboundEmailsBulkDetailsClicksSummaryGridable,
  OutboundEmailsBulkDetailsClicksSummaryExportService,

  OutboundEmailsBulkDetailsClicksColumnService,
  OutboundEmailsBulkDetailsClicksGridable,
  OutboundEmailsBulkDetailsClicksExportService,

  BulkEmailCampaignContactListTempService,
  BulkEmailCampaignContactListTempRepository,
}

export type OutboundEmailsServices = keyof typeof SERVICES

export const OUTBOUND_EMAILS_SERVICES_TYPES = makeServicesTypesFromEnum<OutboundEmailsServices>(SERVICES)
